import { makeStyles, Theme, createStyles } from '@material-ui/core';

export const useNTStyles = makeStyles((theme: Theme) => ({
  formStep: {
    padding: "23px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "fit-content",
  },
  btnPrev: {
    width: "125px",
    marginLeft: "auto",
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "25px",
    },
  },
  btnNext: {
    width: "125px",
    marginLeft: "24px",
    marginRight: "24px",
    display: "flex",
  },
  step: {
    background: "transparent",
    [theme.breakpoints.down("xs")]: {
      width: "113vw",
      position: "relative",
      right: "44px",
    },
  },
  stepLabelStyled: {
    [theme.breakpoints.down("xs")]: {
      "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
        marginTop: "16px",
        fontSize: "12px",
      },
    },
  },
  iconStyleNT: {
    [theme.breakpoints.down("xs")]: {
      marginLeft: -2,
    },
  },
}));

export const useShipmentStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: "0 18px 12px",
    borderRadius: "5px",
    border: "solid 1px #d1e9f0",
    height: "50%",
    width: "70%",
  },
  contentStop: {
    padding: "0 18px 12px",
    borderRadius: "5px",
    border: "solid 1px #d1e9f0",
    height: "50%",
    marginTop: "2%",
    width: "70%",
  },
  pickPoint: {
    padding: "2% 0",
  }

}));
